import * as React from "react";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Box from '@mui/material/Box';
import { visuallyHidden } from '@mui/utils';

export default function UiTableHead(props) {
     const { order, orderBy, onRequestSort } = props;

     const createSortHandler = (property) => (event) => {
          onRequestSort(event, property);
     };

     return (
          <TableHead>
               <TableRow>
                    {props.headings.map(
                         (heading) =>
                              heading.isShow && (
                                   <TableCell
                                        align={heading.align}
                                        key={heading.id}
                                        sx={{width:heading.width}}
                                       
                                        sortDirection={
                                             orderBy === heading.id
                                                  ? order
                                                  : false
                                        }
                                   >
                                        {heading.name && (
                                             <TableSortLabel
                                                  active={
                                                       orderBy === heading.id
                                                  }
                                                  direction={
                                                       orderBy === heading.id
                                                            ? order
                                                            : "asc"
                                                  }
                                                  onClick={createSortHandler(
                                                       heading.id,
                                                  )}
                                             >
                                                  {heading.name}{" "}
                                                 
                                             </TableSortLabel>
                                        )}
                                   </TableCell>
                              ),
                    )}
               </TableRow>
          </TableHead>
     );
}
